import * as types from "../actions/actionTypes";

const initialState = {
  upcoming: {
    totalLeaseEvents: 0,
    leaseEvents: [],
    lastUpdatedLeaseEvent: "",
  },
  snoozed: {
    totalLeaseEvents: 0,
    leaseEvents: [],
    lastUpdatedLeaseEvent: "",
  },
  ignored: {
    totalLeaseEvents: 0,
    leaseEvents: [],
    lastUpdatedLeaseEvent: "",
  },
  details: {},
  byIds: [],
  allLeaseEvents: {},
  allLeaseEvents_snoozed: {},
  allLeaseEvents_ignored: {},
  leaseNames: [],
  cities: [],
  stateProvinces: [],
  countries: [],
  leaseTypes: [],
  leaseStatuses: [],
  eventTypes: [],
  tenureTypes: [],
  propertyTypes: [],
  eventStatuses: [],
  comments: [],
  leaseEventPageSize: 10,
  businessUnits: [],
};

export default function leaseEventReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_LEASE_EVENTS: {
      const { data } = action.payload;

      return {
        ...state,
        upcoming: data,
      };
    }

    case types.GET_LEASE_EVENTS_BY_IDS: {
      const { data } = action.payload;

      return {
        ...state,
        byIds: data,
      };
    }

    case types.GET_LEASE_EVENT: {
      const { data } = action.payload;

      return {
        ...state,
        details: Array.isArray(data) ? data[0] : data,
      };
    }

    case types.GET_LEASE_EVENTS_SNOOZED: {
      const { data } = action.payload;

      return {
        ...state,
        snoozed: data,
      };
    }

    case types.GET_LEASE_EVENTS_IGNORED: {
      const { data } = action.payload;

      return {
        ...state,
        ignored: data,
      };
    }

    case types.GET_LEASE_EVENTS_IGNORED: {
      const { data } = action.payload;

      return {
        ...state,
        ignored: data,
      };
    }

    case types.GET_ALL_LEASE_EVENTS: {
      const { data } = action.payload;

      return {
        ...state,
        allLeaseEvents: data,
      };
    }

    case types.GET_ALL_LEASE_EVENTS_SNOOZED: {
      const { data } = action.payload;

      return {
        ...state,
        allLeaseEvents_snoozed: data,
      };
    }

    case types.GET_ALL_LEASE_EVENTS_IGNORED: {
      const { data } = action.payload;

      return {
        ...state,
        allLeaseEvents_ignored: data,
      };
    }

    case types.GET_LEASE_EVENT_FILTER_OPTIONS: {
      const { data } = action.payload;

      const {
        leaseNames,
        cities,
        stateProvinces,
        countries,
        leaseTypes,
        leaseStatuses,
        tenureTypes,
        propertyTypes,
        eventTypes,
        eventStatuses,
        businessUnits,
      } = data;

      return {
        ...state,
        leaseNames,
        cities,
        stateProvinces,
        countries,
        leaseTypes,
        leaseStatuses,
        tenureTypes,
        propertyTypes,
        eventTypes,
        eventStatuses,
        businessUnits,
      };
    }

    case types.GET_EVENTS_LEASE_NAMES: {
      const { data } = action.payload;

      return {
        ...state,
        leaseNames: data,
      };
    }

    case types.GET_LEASE_EVENT_STATUSES: {
      const { data } = action.payload;

      return {
        ...state,
        eventStatuses: data,
      };
    }

    case types.RESET_LEASE_EVENT_COMMENTS: {
      return {
        ...state,
        comments: [],
      };
    }

    case types.GET_LEASE_EVENT_COMMENTS: {
      const { data } = action.payload;

      return {
        ...state,
        comments: data,
      };
    }

    case types.CREATE_LEASE_EVENT_COMMENT: {
      const { data } = action.payload;
      const {
        commentId,
        comment,
        leaseEventId,
        commentBy,
        commentedDate,
        taggedUsers,
      } = data;

      const newComment = {
        commentId,
        comment,
        leaseEventId,
        commentedDate,
        commentBy,
        taggedUsers
      };

      let copy = [newComment];

      if (state.comments) {
        copy = [...copy, ...state.comments];
      }

      return {
        ...state,
        comments: copy,
      };
    }

    case types.UPDATE_LEASE_EVENT_COMMENT: {
      const { data } = action.payload;      
      const updatedComments = {};

      data.forEach((c) => {
        updatedComments[c.commentId] = {
          commentId: c.commentId,
          comment: c.comment,
          leaseEventId: c.leaseEventId,
          commentedDate: c.commentedDate,
          commentBy: c.commentBy,
          taggedUsers: c.taggedUsers,
        };
      });

      let copy = [];

      if (state.comments) {
        copy = [...state.comments];
      }

      const newComments = copy.map((c) =>
        updatedComments[c.commentId]
          ? { ...c, ...updatedComments[c.commentId] }
          : { ...c }
      );
      return {
        ...state,
        comments: newComments,
      };
    }

    case types.DELETE_LEASE_EVENT_COMMENT: {
      const { commentId } = action.payload;

      return {
        ...state,
        comments: [...state.comments.filter((c) => c.commentId !== commentId)],
      };
    }

    case types.GET_LEASE_EVENT_PAGE_SIZE: {
      const { data } = action.payload || {};
      return {
        ...state,
        leaseEventPageSize: data,
      };
    }

    default:
      return state;
  }
}
